import { sendTrackingEvent } from '../services/service.tracking';
import { getVehicleConfigData } from '../utils/utils.tracking';

const LANDING_VIDEO_EVENT_RESULTS = {
  videoStart: 'video::start',
  videoMilestone: 'video::{milestone}%',
  videoComplete: 'video::complete',
};

export const trackLandingVideo = (name, eventAction, percentage = null) => {
  const eventResult = LANDING_VIDEO_EVENT_RESULTS[name].replace('{milestone}', percentage);

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction,
    eventResult,
    eventNonInteractive: false,
  });
};

export const trackLandingStartMyOffer = (component: string) => {
  const eventResult = `cta::start-my-offer::${component}`;
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult,
    eventNonInteractive: false,
  });
};

export const trackVinScan = (success: boolean, trackEventElement: string) => {
  const eventResult = `button::vin-scan::${success ? 'success' : 'error'}`;
  sendTrackingEvent({
    event: 'analytics_event',
    eventElement: trackEventElement,
    eventAction: 'click',
    eventResult,
    eventNonInteractive: false,
    eventData: { ...getVehicleConfigData() },
  });
};
